// Import 3rd-party dependencies
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

// Import project-specific dependencies
import { ApiService } from '@app/services/api.service';
import { INotificationInfo } from '@app/services/notifications/notification.service';
import { environment } from '@app/environments/environment';
import { APPROVAL_CENTRAL_NOTIFICATIONS_SERVICE_CONSTS } from '@app/config/constants';
import { switchMap } from 'rxjs/operators';

export interface IApprovalsCount {
  [key: string]: string;
  total: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApprovalCentralNotificationService extends ApiService {
  private APPROVALS_URL = environment.DEPS.APPROVAL_CENTRAL.API_URL;
  consts = APPROVAL_CENTRAL_NOTIFICATIONS_SERVICE_CONSTS;

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  getPendingApprovals(coreId: string): Observable<INotificationInfo> {
    return this.get<IApprovalsCount>(`${this.APPROVALS_URL}/requests/count/${coreId}`, {
      where: JSON.stringify({
        status: this.consts.QUERY_STATUS
      })
    }).pipe(
      switchMap((approvals) =>
        of({
          title: this.consts.TITLE,
          link: this.consts.LINK,
          message: this.consts.MESSAGE(Number(approvals.total)),
          count: Number(approvals.total),
          actionNeeded: true,
          origObj: approvals
        })
      )
    );
  }
}
